import { from } from '@apollo/client';

import { configureAuthSessionCacheClear } from 'state/auth/session-transition';
import {
  AuthEpochApolloClient,
  createAuthEpochQueryIsolation,
  resetApolloStateForAuthTransition,
} from 'state/graphql/auth-epoch-query-isolation';
import { getConfiguredCache } from 'state/graphql/cache';
import { commitOrderTestErrorModalLink } from 'state/graphql/links/commit-order-test-error-modal-link';
import { httpLink } from 'state/graphql/links/http-link';
import {
  conditionallyRemoveTypenameFromQueryLink,
  stripTypenameFromVarsLink,
} from 'state/graphql/links/strip-typename';
import { withErrorLogger } from 'state/graphql/links/with-error-logger';
import { withHeaders } from 'state/graphql/links/with-headers';

import { headers } from './headers';
import { withLDFlagsHeader } from './links/with-ld-flags-header';

/**
 * Apollo Client instance
 *
 * Client should only be instantiated once per app
 * @see https://github.com/apollographql/apollo-client-devtools/issues/822
 */
const authEpochQueryIsolation = createAuthEpochQueryIsolation();

export const apolloClient = new AuthEpochApolloClient({
  cache: getConfiguredCache(),
  link: from([
    authEpochQueryIsolation.link,
    withLDFlagsHeader,
    commitOrderTestErrorModalLink,
    withHeaders(headers),
    withErrorLogger,
    stripTypenameFromVarsLink,
    conditionallyRemoveTypenameFromQueryLink,
    httpLink,
  ]),
  headers,
});

configureAuthSessionCacheClear(() =>
  resetApolloStateForAuthTransition(apolloClient, authEpochQueryIsolation)
);
